import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {
  friendsHomepageMock,
  homepageMock,
  activeWaterMock,
  activeFriendWaterMock,
  pickDateMock,
  prayMock,
} from './mock'

export const get_activity_info = async (params = {}) => {
  const res = await http.post(
    '/live/commonactivity/get_activity_info',
    {
      // ...window.store.getState().env.deviceinfo,
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

export const get_homepage = createAsyncThunk(
  'homepage',
  async (p: any, store: any) => {
    // return {...homepageMock, ...p}

    const resp = await http.post(
      '/live/activity/ramadan_afk_active_homepage',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export const ramadan_afk_active_complete_guide = createAsyncThunk(
  'complete_guide',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/ramadan_afk_active_complete_guide',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export const ramadan_afk_active_pick_date = createAsyncThunk(
  'pick_date',
  async (p: any, store: any) => {
    // return pickDateMock

    const resp = await http.post(
      '/live/activity/ramadan_afk_active_pick_date',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export const ramadan_afk_active_water = createAsyncThunk(
  'active_water',
  async (p: any, store: any) => {
    // return activeWaterMock

    const resp = await http.post(
      '/live/activity/ramadan_afk_active_water',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export const ramadan_afk_active_friend_water = createAsyncThunk(
  'active_friend_water',
  async (p: any, store: any) => {
    // return activeFriendWaterMock

    const resp = await http.post(
      '/live/activity/ramadan_afk_active_friend_water',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export const ramadan_afk_active_pray = createAsyncThunk(
  'active_pray',
  async (p: any, store: any) => {
    // return {...prayMock, ...p}

    const resp = await http.post(
      '/live/activity/ramadan_afk_active_pray',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export const get_friend_homepage = createAsyncThunk(
  'friend_homepage',
  async (p: any, store: any) => {
    // return {...friendsHomepageMock, ...p}

    const resp = await http.post(
      '/live/activity/ramadan_afk_active_friend_page',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export type InitialStateType = Record<string, any>

const initialState: InitialStateType = {}

export const ActiveCultivate2026Slice = createSlice({
  name: 'ActiveCultivate2026',
  initialState,
  reducers: {
    updateHomepage: (state, action) => {
      Object.assign(state, {
        ...action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default ActiveCultivate2026Slice.reducer

export const ActiveCultivate2026Actions = ActiveCultivate2026Slice.actions

export const useReducerState = () => {
  const data = useSelector((state) => {
    return state.ActiveCultivate2026
  })
  return data
}
